import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f05af0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content local-registration-container" }
const _hoisted_2 = { class: "date-selector-wrapper" }
const _hoisted_3 = { class: "black-list-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font_family icon-delete1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Del ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font_family icon-tianjia11" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Add ")
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "Focus area special rule",
    closable: true,
    visible: _ctx.visibleModel,
    width: "30%",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            class: "title",
            text: "Black List"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_table, {
              class: "data-table",
              columns: _ctx.columns,
              "data-source": _ctx.data,
              pagination: false,
              rowKey: (record, index) => index
            }, {
              Province: _withCtx(({ record, index }) => [
                _createVNode(_component_a_select, {
                  value: record.selectedProvince,
                  "onUpdate:value": ($event: any) => ((record.selectedProvince) = $event),
                  disabled: !_ctx.inEditing,
                  onChange: (value, option) => _ctx.handleSelectProvince(index, option)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceOptions, (province) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: province.code,
                        key: province.code,
                        title: province.name,
                        disabled: _ctx.selectedProvices.includes(province.code)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(province.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title", "disabled"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "disabled", "onChange"])
              ]),
              City: _withCtx(({ record, index }) => [
                _createVNode(_component_a_select, {
                  mode: "multiple",
                  value: record.selectedCities,
                  "onUpdate:value": ($event: any) => ((record.selectedCities) = $event),
                  disabled: !_ctx.inEditing,
                  onChange: (value, options) => _ctx.handleSelectCity(index, options)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cityOptions, (city) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: city.code,
                        key: city.code,
                        title: city.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(city.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "disabled", "onChange"])
              ]),
              Operation: _withCtx(({ index }) => [
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "del-btn",
                  onClick: ($event: any) => (_ctx.handleDelete(index))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "rowKey"])
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "link",
            class: "add-btn",
            onClick: _ctx.handleAdd
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.inEditing]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_button, {
          class: "m-r-16",
          onClick: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.handleConfirm
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}